import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const OregonMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg id='oregon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' className='map'>
			<polygon
				id='OR_ZE'
				points='480.04 758.82 572.94 759.14 850.48 748.56 839.16 532.1 843.97 498.7 843.12 474.16 821.16 463.53 815.18 440.77 846.35 383.07 857.9 344.9 872.62 306.69 872.98 289.83 861.39 276.1 836.01 252.42 814.66 253.23 732.45 256.45 661.64 257.47 632.5 265.12 563.45 288.04 503.09 301.5 480.04 758.82'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OR_ZE' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OR_ZE')}
			/>
			<polygon
				id='OR_ZW'
				points='503.09 301.5 408.86 296.53 372.83 313.34 353.33 312.07 334.26 300.3 323.28 258.46 301.7 240.17 257.32 226.27 229.88 234.27 220.3 264.74 217.49 311.8 217.77 367.63 211.81 417.91 205.02 462.02 194.01 529.6 192.27 556.41 175.97 588.64 161.24 642.03 171.97 682.9 167.33 713.9 174.46 741.02 191.65 757.83 480.04 758.82 503.09 301.5'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OR_ZW' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OR_ZW')}
			/>
			<rect
				x='632.23'
				y='538.21'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M631.62,577.74l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M688.75,561.8h-14.69l-2.79,14.75h16.55l-.82,4.26h-21.52l7.69-40.44h20.61l-.83,4.25h-15.6l-2.47,12.95h14.71l-.83,4.23Z'
				className='shape'
			/>
			<rect
				x='307.22'
				y='606.03'
				width='84.31'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M306.6,645.55l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M347.38,648.63l-1.98-40.44h5l.86,24.24c.15,5.23.05,7.99,0,10.53h.14c.94-2.64,1.93-5.26,4.16-10.25l11.2-24.53h5.33l.83,23.28c.19,5.24.18,8.75.09,11.42h.13c1.19-3.48,2.4-6.72,3.95-10.41l10.9-24.28h5.22l-18.76,40.44h-5.27l-1.03-23c-.22-4.7-.17-7,.09-11.63h-.15c-1.35,3.88-2.42,6.97-4.09,10.64l-11.28,24h-5.34Z'
				className='shape'
			/>
			<polygon
				points='352.16 316.03 352.27 320.36 356.82 320.36 352.34 323.03 352.44 327.35 349.57 324.68 345.09 327.35 347.79 323.03 344.91 320.36 349.46 320.36 352.16 316.03'
				className='shape'
			/>
			<rect x='242.83' y='329.33' width='100.89' height='20' fill='none' className='shape' />
			<path
				d='M246.62,330.43c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.81-.89,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM247.08,338.21c.56.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.37-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path
				d='M268.79,339.33c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM259.86,341.79c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M272.6,346.37l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M288.47,331.64l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path d='M293.22,346.37l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M308.83,346.37c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM310.12,336.25c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M316.13,346.37l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M343.72,329.33l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM340.38,336.58c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<polygon
				points='323.82 500 323.92 504.32 328.47 504.32 323.99 507 324.1 511.32 321.22 508.65 316.74 511.32 319.44 507 316.57 504.32 321.11 504.32 323.82 500'
				className='shape'
			/>
			<rect x='234.11' y='484' width='85.83' height='20' fill='none' className='shape' />
			<path
				d='M244.17,493.44h-5.88l-1.12,5.9h6.62l-.33,1.7h-8.61l3.08-16.18h8.24l-.33,1.7h-6.24l-.99,5.18h5.89l-.33,1.69Z'
				className='shape'
			/>
			<path
				d='M259.68,489.43l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.19.22-1.96l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M263.41,503.68c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM272.33,491.16c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M286.68,500.38c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM284.47,490.72c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M291.6,501.04l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M315.21,500.38c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM313.01,490.72c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='507.25 515.18 507.36 519.51 511.9 519.51 507.42 522.18 507.53 526.5 504.65 523.83 500.17 526.5 502.88 522.18 500 519.51 504.55 519.51 507.25 515.18'
				className='shape'
			/>
			<rect x='511.85' y='521.44' width='59.84' height='20' fill='none' className='shape' />
			<path
				d='M515.62,522.53c.99-.2,2.15-.34,3.47-.34,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.09-3.35-.23l2.99-15.83ZM514.86,536.87c.5.08,1.09.11,1.64.11,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM516.34,529.17h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M535.85,537.82c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM533.65,528.16c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M540.78,538.48l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M568.36,521.44l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM565.02,528.69c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<polygon
				points='329.74 392.88 329.85 397.2 334.39 397.2 329.92 399.87 330.02 404.2 327.15 401.53 322.67 404.2 325.37 399.87 322.49 397.2 327.04 397.2 329.74 392.88'
				className='shape'
			/>
			<rect x='334.34' y='399.14' width='70.82' height='20' fill='none' className='shape' />
			<path
				d='M335.34,413.67c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.03-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M356.54,416.18c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM357.84,406.05c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M363.81,416.18l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M380.09,415.51c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM377.89,405.85c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M385.02,416.18l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<polygon
				points='304.01 712.1 304.12 716.42 308.67 716.42 304.19 719.09 304.29 723.42 301.42 720.74 296.94 723.42 299.64 719.09 296.76 716.42 301.31 716.42 304.01 712.1'
				className='shape'
			/>
			<rect x='308.62' y='718.35' width='96.54' height='20' fill='none' className='shape' />
			<path
				d='M322.92,735.39l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.4h-.05c-.34,1.5-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.19-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M338.81,734.73c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM336.61,725.07c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M356.11,718.35l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM352.76,725.6c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M359.06,735.39l1.9-10.04h-1.55l.3-1.56h1.55l.11-.62c.28-1.61.86-3.11,1.9-4.05.74-.66,1.75-1.03,2.75-1.03.8,0,1.32.15,1.59.31l-.43,1.59c-.31-.15-.71-.23-1.17-.23-1.58,0-2.35,1.54-2.69,3.46l-.1.56h2.59l-.31,1.56h-2.58l-1.91,10.04h-1.98Z'
				className='shape'
			/>
			<path
				d='M379.09,728.35c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM370.16,730.81c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M382.9,735.39l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M405.16,718.35l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM401.82,725.6c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<polygon
				points='755.07 408.06 755.17 412.39 759.72 412.39 755.24 415.06 755.35 419.38 752.47 416.71 747.99 419.38 750.69 415.06 747.82 412.39 752.36 412.39 755.07 408.06'
				className='shape'
			/>
			<rect x='633.7' y='389.14' width='118.16' height='20' fill='none' className='shape' />
			<path
				d='M637.48,390.22c.99-.2,2.15-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM636.71,404.57c.51.08,1.09.1,1.64.1,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM638.2,396.86h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.25Z'
				className='shape'
			/>
			<path
				d='M657.01,406.18c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM658.3,396.05c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M664.27,406.18l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.77,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M685.67,405.51c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM683.47,395.85c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M690.59,406.18l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M718.69,405.65c-.91.41-2.38.78-4.2.78-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M723.16,406.18l2.22-11.61h1.99l-2.22,11.61h-1.99ZM725.75,391.33c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M736.28,391.45l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M743.81,394.57l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
		</svg>
	);
};

OregonMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default OregonMap;
